import { observer } from 'mobx-react-lite';
import React, { CSSProperties } from 'react';
import { ThemeProvider } from 'styled-components';
import { themeState } from 'styleguide/theme';

interface SvgProps {
  tint?: string;
  style?: CSSProperties;
}

function SvgPadlock(props: SvgProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.5 13.5C12.5 13.7761 12.2761 14 12 14H4C3.72386 14 3.5 13.7761 3.5 13.5V8.5C3.5 8.22386 3.72386 8 4 8H12C12.2761 8 12.5 8.22386 12.5 8.5V13.5Z"
        fill={props.tint}
        stroke={props.tint}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M11 8V4.84052C11 3.27323 9.65859 2 8 2C6.34141 2 5 3.27323 5 4.84052V8"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
}

function SvgReps(props: SvgProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.523 5.236H14.4V2.36"
        stroke={props.tint}
        strokeWidth={1.5}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M11.955 11.745a6.328 6.328 0 110-8.946L14 4.838"
        stroke={props.tint}
        strokeWidth={1.5}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgSets(props: SvgProps) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.666 4h10.667M2.666 12h2.667M2.666 8h6.667"
        stroke={props.tint}
        strokeWidth={1.5}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgChevronDown(props: SvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M3 6L8 11L13 6"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgChevronRight(props: SvgProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 13L11 8L6 3"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgChevronLeft(props: SvgProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 3L5 8L10 13"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgCheck(props: SvgProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 3L5 13L1 9"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgPlus(props: SvgProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 2V14M2 8H14"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgCross(props: SvgProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2548_3278)">
        <path
          d="M12.2426 3.75729L3.75736 12.2426M3.75736 3.75729L12.2426 12.2426"
          stroke={props.tint}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2548_3278">
          <rect width="16" height="16" fill={props.tint} />
        </clipPath>
      </defs>
    </svg>
  );
}

function SvgTimer(props: SvgProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3356_1895)">
        <path
          d="M8 9L10.4706 6.52941M14 9C14 12.3137 11.3137 15 8 15C4.68629 15 2 12.3137 2 9C2 5.68629 4.68629 3 8 3C11.3137 3 14 5.68629 14 9Z"
          stroke={props.tint}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.25 1.00182L9.75 1"
          stroke={props.tint}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3356_1895">
          <rect width="16" height="16" fill={props.tint} />
        </clipPath>
      </defs>
    </svg>
  );
}

interface MicroIconProps {
  type: MicroIconType;
  tint?: string;
  style?: CSSProperties;
  dark?: string;
  light?: string;
}

export const MicroIcon = observer((props: MicroIconProps) => {
  const tint = props.tint ?? (props[themeState.current.name] || themeState.current.primary);

  return (
    <ThemeProvider theme={themeState.current}>
      <MicroIcons tint={tint} {...props} style={{ width: 16, height: 16, ...props.style }} />
    </ThemeProvider>
  );
});

export type MicroIconType =
  | 'padlock'
  | 'reps'
  | 'sets'
  | 'timer'
  | 'chevron-down'
  | 'chevron-right'
  | 'chevron-left'
  | 'check'
  | 'plus'
  | 'cross';

const MicroIcons = (props: MicroIconProps) => {
  switch (props.type) {
    case 'padlock':
      return <SvgPadlock {...props} />;
    case 'reps':
      return <SvgReps {...props} />;
    case 'sets':
      return <SvgSets {...props} />;
    case 'timer':
      return <SvgTimer {...props} />;
    case 'chevron-down':
      return <SvgChevronDown {...props} />;
    case 'chevron-right':
      return (
        <SvgChevronRight
          {...props}
          style={document.documentElement.dir === 'rtl' ? { transform: 'scaleX(-1)' } : undefined}
        />
      );
    case 'chevron-left':
      return (
        <SvgChevronLeft
          {...props}
          style={document.documentElement.dir === 'rtl' ? { transform: 'scaleX(-1)' } : undefined}
        />
      );
    case 'check':
      return <SvgCheck {...props} />;
    case 'plus':
      return <SvgPlus {...props} />;
    case 'cross':
      return <SvgCross {...props} />;
  }
};
